var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4.85 12.825 3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325L8 3.125 6.55 6.5l-3.65.325L5.675 9.25l-.825 3.575ZM8 12.689l-3.89 2.345a.72.72 0 0 1-.436.107.791.791 0 0 1-.395-.147.84.84 0 0 1-.273-.332.649.649 0 0 1-.03-.453l1.032-4.417L.573 6.82a.736.736 0 0 1-.245-.387.702.702 0 0 1 .028-.428.845.845 0 0 1 .233-.34.808.808 0 0 1 .415-.172l4.533-.396L7.297.925a.678.678 0 0 1 .29-.344.82.82 0 0 1 .826 0c.13.074.227.189.29.344l1.76 4.171 4.533.396a.808.808 0 0 1 .416.172c.101.088.178.201.232.34a.701.701 0 0 1 .028.428.735.735 0 0 1-.245.387l-3.435 2.973 1.033 4.418a.649.649 0 0 1-.03.452.84.84 0 0 1-.274.332.791.791 0 0 1-.395.147.72.72 0 0 1-.436-.107L8 12.688Z",
  fill: "#D80073"
})));

export default SvgStar;